import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Siren } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const ALERTE_TYPES = [['decrochage', 'Décrochage'], ['comportement', 'Comportement'], ['assiduite', 'Assiduité'], ['difficulte', "Difficulté d'apprentissage"], ['autre', 'Autre']];

// Alerte du formateur sur un candidat (décrochage, comportement…) avec mesures correctives / conseils
export const AlerteFormateurDialog = ({ candidat, dossierId, date, onClose, onDone }) => {
  const [form, setForm] = useState({ type: 'decrochage', description: '', mesures: '' });
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    setSaving(true);
    try {
      await axios.post(`${API_URL}/portail/formateur/journee/${dossierId}/${date}/alerte-formateur`, { candidat_id: candidat.id, ...form });
      toast.success("Alerte transmise au responsable pédagogique");
      onDone?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="alerte-formateur-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Siren className="w-5 h-5 text-orange-500" /> Alerte formateur — {candidat.nom} {candidat.prenom}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Signalez un décrochage, un comportement inadapté ou toute difficulté : le responsable pédagogique est alerté et l'entreprise / le financeur la verront sur la fiche du candidat.</p>
        <div className="space-y-3 text-sm">
          <label className="block space-y-1"><span className="text-xs font-semibold text-slate-500">Nature de l'alerte</span>
            <select className="w-full h-9 rounded-md border border-slate-200 bg-white px-2 text-sm" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="alerte-type-select">
              {ALERTE_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select></label>
          <label className="block space-y-1"><span className="text-xs font-semibold text-slate-500">Constat</span>
            <Textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Ce que vous observez : désengagement, retards, attitude, résultats en baisse…" data-testid="alerte-description-input" /></label>
          <label className="block space-y-1"><span className="text-xs font-semibold text-emerald-700">Mesures correctives / conseils</span>
            <Textarea rows={3} value={form.mesures} onChange={(e) => setForm({ ...form, mesures: e.target.value })} placeholder="Entretien individuel, accompagnement renforcé, rappel du cadre, aménagement, contact entreprise…" className="border-emerald-200" data-testid="alerte-mesures-input" /></label>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
          <Button type="button" className="bg-orange-600 hover:bg-orange-700" disabled={saving || !form.description.trim()} onClick={submit} data-testid="alerte-submit-btn">Émettre l'alerte</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
